import { render } from "./ExerciciosFormulario.vue?vue&type=template&id=51c7d158"
import script from "./ExerciciosFormulario.vue?vue&type=script&lang=js"
export * from "./ExerciciosFormulario.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__